import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/index.vue'
import List from '@/views/datalist.vue'
import newIndex from '@/views/newIndex.vue'
import Celebration from '@/views/celebration.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/index',
      name: 'Index',
      component: Home
    },
    {
      path: '/list',
      name: 'list',
      component: List
    },
    {
      path: '/newIndex',
      name: 'newIndex',
      component: newIndex
    },
    {
      path: '/celebration',
      name: 'celebration',
      component: Celebration
    },
    // {
    //   path:"/groupperson",
    //   name:"groupperson",
    //   component:()=>import("../views/group/person.vue")
    // },
    {
      path:"/groupgrade",
      name:"groupgrade",
      component:()=>import("../views/group/grade.vue")
    },
    {
      path:"/persontwo",
      name:"persontwo",
      component:()=>import("../views/group/persontwo.vue")
    },
    {
      path:"/personThree",
      name:"personThree",
      component:()=>import("../views/group/personThree.vue")
    },
    {
      path:"/rank",
      name:"rank",
      component:()=>import("../views/group/rank.vue")
    },
    {
      path:"/lz_meeting",
      name:"lz_meeting",
      component:()=>import("../views/lz_meeting.vue")
    },
    // {
    //   path:"/barrage",
    //   name:"barrage",
    //   component:()=>import("../views/group/component/barrage3.vue")
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js